export default __webpack_public_path__ + "/static/media/login_bg.efa33de8.jpg";